import * as ACTION_TYPE from "./action-types";

/**
 * set taskBookmarks state
 * @param {data Array}
 */
export const setTaskBookmarks = (data) => {
  return {
    type: ACTION_TYPE.GET_TASK_BOOKMARKS,
    payload: data ? data : [],
  };
};

/**
 * set projectBookmarks state
 * @param {data Array}
 */
export const setProjectBookmarks = (data) => {
  return {
    type: ACTION_TYPE.GET_PROJECT_BOOKMARKS,
    payload: data ? data : [],
  };
};

/**
 * set projectBookmarks state
 * @param {data Array}
 */
export const setQueueBookmarks = (data) => {
  return {
    type: ACTION_TYPE.GET_QUEUE_BOOKMARKS,
    payload: data ? data : [],
  };
};

/**
 * set libraryBookmarks state
 * @param {data Array}
 */
export const setLibraryBookmarks = (data) => {
  return {
    type: ACTION_TYPE.GET_LIBRARY_BOOKMARKS,
    payload: data ? data : [],
  };
};

/**
 * set favouriteFilters state — list of filters the current user has starred
 * in the Views tab; rendered by the sidebar Filters hover panel.
 * @param {Array} data
 */
export const setFavouriteFilters = (data) => {
  return {
    type: ACTION_TYPE.SET_FAVOURITE_FILTERS,
    payload: data ? data : [],
  };
};
